import styled from 'styled-components';
import { Button, Card, Spacer, Text, TextButton  } from '@zillow/constellation';
import type { CardProps  } from '@zillow/constellation';

export const Content = styled(Card as React.ForwardRefExoticComponent<CardProps>)`
    max-width: 550px;
    min-width: 250px;
    clamp(15px, 7%, 50px);
`;

export const CenterText = styled(Text)`
  text-align: center;
`;

export const CenterButton = styled(Button)`
  text-align: center;
  margin: auto;
`;

export const FixedWidthButton = styled(Button)<{ width: number }>`
  width: ${(params) => params.width}px;
`;

export const CenterSpacer = styled(Spacer)`
  text-align: center;
`;

export const SizeTwentyText = styled(Text)`
  font-size: 20;
`;

export const SizeTwentyTextButton = styled(TextButton)`
  font-size: 20;
`;
